export const type = {
    string: "string",
    number: "number",
    object: "object",
    null: "null",
    undefined: "undefined",
}

export const boolean = {
    true: true,
    false: false,
    trueStringLower: "true",
    falseStringLower: "false",
    trueStringCamal: "True",
    falseStringCamal: "False",
    trueStringUpper: "TRUE",
    falseStringUpper: "FALSE",
}

export const inputType = {
    text: "text",
    password: "password",
    number: "number",
    date: "date",
    time: "time",
    select: "select",
    search: "search",
    checkbox: "checkbox",
    radio: "radio",
    toggle: "toggle",
}

export const errors = {
    wrongType: "Wrong Input Type",
}

export const isValue = {
    emptyString: "",
    highlighttabcls: 'highlighttabcls'
}

export const dateFormat = {
    YYYY_MM_DD: "YYYY-MM-DD",
    HH_mm: "HH:mm",
    DDMMMYY: "DDMMMYY",
    hmm_A: "h:mm A",
    YYYYMMDDhhmm: "YYYY-MM-DD hh:mm",
    LL: "LL",
    h_mm: "h:mm",
    H_mm: "H:mm",
    YYYY_MM_DD_HH_MM: "YYYY-MM-DD HH:MM",
    YYYY_MM_DD_HH_mm_ss: "YYYY-MM-DD HH:mm:ss"
}

export const HeadData = {
    logs: "logs",
    more_info: 'more info',
    VISUALIZE: 'VISUALIZE',
    actions: "actions",
    addtionalInfo: "addtionalInfo",
    S_NO: "S.no",
    SCHEDULE_TIME: "SCHEDULE TIME",
    STATUS: "STATUS",
    GDS: "gds",
    chartGroup: "Chart Groups",
    shopGroup: "shop Groups",
    groupItem: "Group Items"
}

export const cabinclass = {
    Economy: "Economy",
    Business: "Business",
    First_Class: "First Class"
}

export const notification_msg = [
    {
        heading: "Data Manager",
        message: "Check out the Data Manager section to monitor the extraction insights for your shops."
    },
    {
        heading: "Clone Comps",
        message: "Use the clone button to create a comps with the same parameters.",
    }
]

export const defaultFlightShopsFilter = {
    shopName: isValue?.emptyString,
    flyFrom: isValue?.emptyString,
    flyTo: isValue?.emptyString,
    outputtype: isValue?.emptyString,
    routeType: 0,
    status: 1,
    source: isValue?.emptyString,
    cabinClass: isValue?.emptyString,
    currency: isValue?.emptyString,
    pos: isValue?.emptyString,
    frequency: isValue?.emptyString,
    days: [],
    "page": 1,
    "pageSize": 100,
    groupshop: [],
    groupId: isValue?.emptyString,
}

export const defaultFlightShopGroupFilter = {
    groupName: isValue?.emptyString,
    marketFrom: isValue?.emptyString,
    marketTo: isValue?.emptyString,
    shops: [],
    shopid: "",
}

export const DOTS = '...';

export const dashboardItems = [
    {
        "_id": "65685ae5c1d0ca977aec6b1c",
        "itemName": "Flight Schedule",
        "description": "Navigate the skies with our Flight Schedule dashboard: effortlessly track who's taking flight for each day and departure time, and the corresponding prices. Compare your offerings with other airlines and evaluate competitiveness by scrutinizing the frequency of flights, identifying gaps in schedules, evaluating prices and discerning the availability  of direct flights.",

    },
    {
        "_id": "656869eaf3d0725fc7e7402c",
        "itemName": "Price Distribution",
        "description": "Dive into pricing insights with our Price Distribution dashboard: explore and compare the price range across different competitors, identify frequent price points, and spot price concentration areas.",

    },
    {
        "_id": "65686ab2f3d0725fc7e7402d",
        "itemName": "Price Horizon",
        "description": "Explore airfares in the future with our Price Horizon dashboard: analyze pricing trends for a range of upcoming days, compare your rates to competitors, and benchmark against the market price range, gaining valuable insights for strategic pricing decisions.",

    },
    {
        "_id": "65687975005405f11fcafd8e",
        "itemName": "Ranking Analysis",
        "description": "Dive into competition insights with our Ranking Analysis dashboard: effortlessly assess daily rankings of airlines based on price or duration, allowing you to identify industry leaders and strategically position yourself among competitors for each day within your selected future horizon.",

    },
    {
        "_id": "65687df4005405f11fcafd90",
        "itemName": "Rate Parity",
        "description": "Refine pricing strategies with our Rate Parity dashboard: compare your flight prices across several OTAs, identify undercuts, overpricing, and inventory differences for sharper decision-making.",

    },
    {
        "_id": "65689e7dd5d7cf4861a1468e",
        "itemName": "Price Evolution",
        "description": "Decode competitors' pricing strategies with our Price Evolution dashboard: unravel the last 30 or 60-day dynamics of the lowest available rates for each future departure date. Gain insights into price volatility, total variations and recent price updates, discerning the evolution of competitors' pricing tactics for strategic decision-making.",

    },
    {
        "_id": "65f3de092df5dba4aeafc09c",
        "itemName": "Test_QAlibrary1",
        "description": "Delve into future pricing trends with our 'Price Trend' category: analyze and compare upcoming airfares, price distributions, flight schedules, rankings, and disparities across OTAs for insightful decision-making in your pricing strategy.",

    }
]

export const libraryItems = [
    {
        "_id": "65685ae5c1d0ca977aec6b1c",
        "itemName": "Flight Schedule",
        "description": "Navigate the skies with our Flight Schedule dashboard: effortlessly track who's taking flight for each day and departure time, and the corresponding prices. Compare your offerings with other airlines and evaluate competitiveness by scrutinizing the frequency of flights, identifying gaps in schedules, evaluating prices and discerning the availability  of direct flights.",

    },
    {
        "_id": "656869eaf3d0725fc7e7402c",
        "itemName": "Price Distribution",
        "description": "Dive into pricing insights with our Price Distribution dashboard: explore and compare the price range across different competitors, identify frequent price points, and spot price concentration areas.",

    },
    {
        "_id": "65686ab2f3d0725fc7e7402d",
        "itemName": "Price Horizon",
        "description": "Explore airfares in the future with our Price Horizon dashboard: analyze pricing trends for a range of upcoming days, compare your rates to competitors, and benchmark against the market price range, gaining valuable insights for strategic pricing decisions.",

    },
    {
        "_id": "65687975005405f11fcafd8e",
        "itemName": "Ranking Analysis",
        "description": "Dive into competition insights with our Ranking Analysis dashboard: effortlessly assess daily rankings of airlines based on price or duration, allowing you to identify industry leaders and strategically position yourself among competitors for each day within your selected future horizon.",

    },
    {
        "_id": "65687df4005405f11fcafd90",
        "itemName": "Rate Parity",
        "description": "Refine pricing strategies with our Rate Parity dashboard: compare your flight prices across several OTAs, identify undercuts, overpricing, and inventory differences for sharper decision-making.",

    },
    {
        "_id": "65689e7dd5d7cf4861a1468e",
        "itemName": "Price Evolution",
        "description": "Decode competitors' pricing strategies with our Price Evolution dashboard: unravel the last 30 or 60-day dynamics of the lowest available rates for each future departure date. Gain insights into price volatility, total variations and recent price updates, discerning the evolution of competitors' pricing tactics for strategic decision-making.",

    },
    {
        "_id": "65f3de092df5dba4aeafc09c",
        "itemName": "Test_QAlibrary1",
        "description": "Delve into future pricing trends with our 'Price Trend' category: analyze and compare upcoming airfares, price distributions, flight schedules, rankings, and disparities across OTAs for insightful decision-making in your pricing strategy.",

    }
]

export const defaultPayload = {
    rateparityData: false,
    historicalData: false,
    historicalHorizon: "",
    metasources: [],
    otasources: []
}

export const faretrackReadUsers = ["qc@faretrack.ai", "balam@aggregateintelligence.com"]

export const historyOptions = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
    11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
    31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
    41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
    51, 52, 53, 54, 55, 56, 57, 58, 59, 60
]
export const frequencyOptions = [
    { label: "Daily", value: "Daily" },
    { label: "Weekly", value: "Weekly" },
    { label: "Monthly", value: "Monthly" },
    { label: "Custom", value: "Custom" },
];
export const weekOptions = [
    { label: "SUN", value: 0 },
    { label: "MON", value: 1 },
    { label: "TUE", value: 2 },
    { label: "WED", value: 3 },
    { label: "THU", value: 4 },
    { label: "FRI", value: 5 },
    { label: "SAT", value: 6 },
]
export const monthOptions = [
    { label: '1st', value: 1 },
    { label: '2nd', value: 2 },
    { label: '3rd', value: 3 },
    { label: '4th', value: 4 },
    { label: '5th', value: 5 },
    { label: '6th', value: 6 },
    { label: '7th', value: 7 },
    { label: '8th', value: 8 },
    { label: '9th', value: 9 },
    { label: '10th', value: 10 },
    { label: '11th', value: 11 },
    { label: '12th', value: 12 },
    { label: '13th', value: 13 },
    { label: '14th', value: 14 },
    { label: '15th', value: 15 },
    { label: '16th', value: 16 },
    { label: '17th', value: 17 },
    { label: '18th', value: 18 },
    { label: '19th', value: 19 },
    { label: '20th', value: 20 },
    { label: '21st', value: 21 },
    { label: '22nd', value: 22 },
    { label: '23rd', value: 23 },
    { label: '24th', value: 24 },
    { label: '25th', value: 25 },
    { label: '26th', value: 26 },
    { label: '27th', value: 27 },
    { label: '28th', value: 28 },
    { label: '29th', value: 29 },
    { label: '30th', value: 30 },
    { label: '31st', value: 31 }
]

export const monthWeekOptions = [
    { label: '1st', value: 1 },
    { label: '2nd', value: 2 },
    { label: '3rd', value: 3 },
    { label: '4th', value: 4 },
    { label: '5th', value: 5 }
]